import { useQuery, useQueryClient, useMutation } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useSecurity = (config) => {
  return useQuery({
    ...config,
    queryKey: "settings-security",
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/security`,
        signal,
      }),
  });
};

export const useUpdateSecurity = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (data) =>
      fetch({
        url: `${Angie.api_url}/security`,
        method: "PUT",
        body: data,
      }),
    onSuccess: () => {
      client.invalidateQueries("settings-security");
    },
  });
};
